<template>
  <div class="flex flex-col items-center">
    <b class="block font-normal drop-shadow-[0_1px_2px_rgba(0,0,0,.3)]">
      受講開始
      <span class="co-display-8 mx-1 font-bold">
        {{ dateToMonth(beginsAt) }}
      </span>
      月
      <span class="co-display-8 mx-1 font-bold">
        {{ dateToDay(beginsAt) }}
      </span>
      日（{{ dateToWeek(beginsAt) }}）
    </b>
    <TeCommonBalloon
      v-show="showNotification === 'today'"
      class="rounded border-[rgba(0,0,0,0.5)] bg-[rgba(0,0,0,0.5)]"
      style="vertical-align: 8px"
    >
      <FontAwesomeIcon
        :icon="faTriangleExclamation"
        class="fa-fw co-display-8 inline size-6"
      />
      申込締切（本日締切）
      <span class="block sm:inline">
        <span class="co-display-8 mx-1 font-bold">
          {{ dateToMonth(yesterdayClosesAt) }}
        </span>
        月
        <span class="co-display-8 mx-1 font-bold">
          {{ dateToDay(yesterdayClosesAt) }}
        </span>
        日（{{ dateToWeek(yesterdayClosesAt) }}）
        <span class="co-display-8 mx-1 font-bold">
          {{ dateToHours(yesterdayClosesAt) }}
        </span>
        時
      </span>
    </TeCommonBalloon>
    <TeCommonBalloon
      v-show="showNotification === 'aLittleLeft'"
      class="rounded border-[rgba(0,0,0,0.5)] bg-[rgba(0,0,0,0.5)]"
      style="vertical-align: 8px"
    >
      <FontAwesomeIcon
        :icon="faClockNine"
        class="fa-fw co-display-8 -mb-1 inline size-6"
      />
      申込締切（残りわずか）
      <span class="block sm:inline">
        <span class="co-display-8 mx-1 font-bold">
          {{ dateToMonth(yesterdayClosesAt) }}
        </span>
        月
        <span class="co-display-8 mx-1 font-bold">
          {{ dateToDay(yesterdayClosesAt) }}
        </span>
        日（{{ dateToWeek(yesterdayClosesAt) }}）
        <span class="co-display-8 mx-1 font-bold">
          {{ dateToHours(yesterdayClosesAt) }}
        </span>
        時
      </span>
    </TeCommonBalloon>
    <span v-show="!showNotification">
      <span>
        申込締切
      </span>
      <b class="co-display-8 mx-1 font-bold">
        {{ dateToMonth(yesterdayClosesAt) }}
      </b>
      月
      <b class="co-display-8 mx-1 font-bold">
        {{ dateToDay(yesterdayClosesAt) }}
      </b>
      日（{{ dateToWeek(yesterdayClosesAt) }}）
      <b class="co-display-8 mx-1 font-bold">
        {{ dateToHours(yesterdayClosesAt) }}
      </b>
      時
    </span>
    <a
      class="co-btn-ghost-white mt-5 rounded-full border-2 tracking-[.15em]"
      href="#apply"
      @click.prevent="scrollTo('apply')"
    >
      今すぐ申し込む
    </a>
  </div>
</template>

<script lang="ts">
import { dateToYesterday, formatDayOfWeek } from '~/utility/utility'
import TeCommonBalloon from '~/components/Te/TeCommon/Balloon/TeCommonBalloon/TeCommonBalloon.vue'

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faTriangleExclamation } from '@awesome.me/kit-65d95819ce/icons/classic/solid'
import { faClockNine } from '@awesome.me/kit-65d95819ce/icons/classic/regular'

interface Props {
  pack: any
}

const options = {
  async setup() {
    return {
      faTriangleExclamation,
      faClockNine,
    }
  },
  props: {
    pack: {
      default: null,
    },
  },
  computed: {
    beginsAt(): Date | null {
      return this.pack ? new Date(this.pack.attributes.begins_at) : null
    },
    fuelStartsAt(): Date | null {
      return this.pack ? new Date(this.pack.attributes.fuel_starts_at) : null
    },
    closesAt(): Date | null {
      return this.pack ? new Date(this.pack.attributes.closes_at) : null
    },
    yesterdayClosesAt(): Date | null {
      if (!this.closesAt) return null
      const newDate = new Date(this.closesAt)
      return dateToYesterday(newDate)
    },
    showNotification(): 'today' | 'aLittleLeft' | null {
      if (!this.closesAt) return null
      const now = new Date()
      const leftDays =
        (this.closesAt.valueOf() - now.valueOf()) / (1000 * 60 * 60 * 24)
      if (leftDays > 0 && leftDays < 1) {
        return 'today'
      } else if (this.fuelStartsAt && this.fuelStartsAt < now) {
        return 'aLittleLeft'
      } else {
        return null
      }
    },
  },
  methods: {
    dateToMonth(date: Date | null): number | '-' {
      return date ? date.getMonth() + 1 : '-'
    },
    dateToDay(date: Date | null): number | '-' {
      return date ? date.getDate() : '-'
    },
    dateToHours(date: Date | null): number | '-' {
      return date ? date.getHours() + 24 : '-'
    },
    dateToWeek(date: Date | null): string {
      if (date) {
        const dayOfWeek = formatDayOfWeek(date, false)
        return dayOfWeek as
          | '日'
          | '月'
          | '火'
          | '水'
          | '木'
          | '金'
          | '土'
          | '祝'
      } else {
        return '-'
      }
    },
  },
  components: {
    TeCommonBalloon,
    FontAwesomeIcon,
  },
}

export default defineNuxtComponent(options)
</script>
